var exports = {
  "As": "AccordionItem__bb5ErO",
  "c4": "AccordionItem__heading__MTWOf1",
  "Zw": "AccordionItem__content__rdHVi3",
  "SH": "AccordionItem__content--expanded__eNFic4",
};

module.exports = exports;
